import React, { useEffect, useState } from 'react';
import Progress from '../progress';
import CyberChart from './chart.js';
// import '@style/modules/analysis/cyberSecurity.scss';
import '../../../../styles/modules/analysis/cyberSecurity.scss';
import moment from 'moment';
import { useSelector } from 'react-redux';

const COLORS = {
  ORANGE: '#D04A02',
  LIGHTBLUE: '#80C4F5',
  BLUE: '#006CE2',
  GREY: '#464646',
};

const formatter = (s, g) =>
  s ? (
    <>
      <div className="circle-grade">{g}</div>
      <div className="circle-score">
        {' '}
        <span className="text-left">{String(s)} </span>
        <span>/ 100</span>
      </div>
    </>
  ) : (
    'N/A'
  );

const ScoreCircle = ({ score, grade, color }) => (
  <div className={`a-score-circle `}>
    <Progress
      type="circle"
      percent={score}
      trailColor={COLORS.GREY}
      strokeColor={color}
      format={() => formatter(score, grade)}
      width={168}
      strokeWidth={13}
      strokeLinecap="square"
      className="a-bigger-score-circle"
    />
  </div>
);

const CyberSecurity = ({ data }) => {
  const [leftData, setLeftData] = useState([]);
  const [rightData, setRightData] = useState(null);

  const { buyerLabel, targetLabel } = useSelector(
    ({ common }) => common.projectCompanyInfo,
  );

  useEffect(() => {
    if (data?.buyerCybersecurity) {
      const res = Object.values(data).reduce(
        (cur, item, i) => {
          for (const [key, value] of Object.entries(item)) {
            if (
              [
                'companyName',
                'overallGrade',
                'overallScore',
                'updateDate',
              ].includes(key)
            ) {
              cur.leftData[i][key] = value;
            } else {
              cur.rightData[i === 0 ? 'buyer' : 'target'][key] = value;
            }
          }

          return cur;
        },
        {
          leftData: [
            { role: buyerLabel, color: COLORS.BLUE },
            { role: targetLabel, color: COLORS.LIGHTBLUE },
          ],
          rightData: { buyer: {}, target: {} },
        },
      );

      setLeftData(res.leftData);
      setRightData(res.rightData);
    }
  }, [data]);

  return (
    <div className="cyberSecurity-container">
      {/* <div className="rating-title">Overall Rating</div> */}
      <div className="left">
        {leftData.map(
          ({
            role,
            companyName,
            overallScore,
            overallGrade,
            updateDate,
            color,
          }) => (
            <div className="rating-all" key={role}>
              <div className="role-text">{role}</div>
              <div className="cyber-company-name">{companyName}</div>
              <ScoreCircle
                score={overallScore}
                grade={overallGrade}
                color={color}
              />
              <div className="date">
                Updated on {moment(updateDate).format(`MM/DD/YYYY`)}
              </div>
            </div>
          ),
        )}
      </div>
      <div className="right">
        <CyberChart data={rightData} />
      </div>
    </div>
  );
};

export default CyberSecurity;
